import { apiRequest } from '../../../../shared/api/index.js';

export const dismissAttention = async (id: string): Promise<void> => {
  await apiRequest<void>(`/attention/${encodeURIComponent(id)}/dismiss`, { method: 'POST' });
};
